import "core-js/modules/web.dom-collections.iterator.js";
import React, { useEffect } from "react";
import { ErrorNotice } from "@jutro/components";
import { useAuth } from "@jutro/auth";
import { log } from "@jutro/logger";
import { messages } from "./AuthErrorPage.messages";
export const AuthErrorPage = (_ref) => {
  let error = _ref.error,
    errorMappers = _ref.errorMappers;
  const _useMessageDetails = ((error, handlers) => {
      var _error$cause;
      const auth = useAuth();
      if (
        "access_denied" ===
        (null === (_error$cause = error.cause) || void 0 === _error$cause
          ? void 0
          : _error$cause.error)
      )
        return {
          name: 'Authentication Error',
          message: 'We\'re sorry, an authentication error has occurred, please click \'RELOAD\' to try again.',
          actions: [{ 
            label: 'Reload', 
            callback: () => { 
                const currentLocation = window.location.href;
                const isProd = currentLocation.includes('fwsprod');

                const ssoBase = (isProd)
                    ? 'https://fwsia.okta.com/app/fwsia_guidewirecloud_1/exkwynw8voRWCDNMQ696/sso/saml?RelayState='
                    : 'https://fwsia.oktapreview.com/app/fwsia_guidewirecloud_1/exk3m7ez89hipdU371d7/sso/saml?RelayState=';

                window.location.href= `${ssoBase}${currentLocation}`
            }            
          }],
        };
      for (const handler of handlers) {
        const details = handler(error);
        if (details) return details;
      }
      return {
        name: messages.authErrorTitle,
        message: messages.genericAuthErrorMessage,
        actions: [
          { label: messages.reload, callback: () => window.location.reload() },
        ],
      };
    })(error, errorMappers || []),
    name = _useMessageDetails.name,
    message = _useMessageDetails.message,
    actions = _useMessageDetails.actions;
  return (
    useEffect(() => {
      log.error(error.toString());
    }, [error]),
    React.createElement(ErrorNotice, {
      noticeStyle: "fullHeight",
      mainMessage: name,
      detailedMessage: message,
      actions: actions,
    })
  );
};